export const EVENT = {
    CLICK_TILE: 'ClickTile',
    TOGGLE_DEFOG_TILE: 'ToggleDefog',
    DEFOG_TILE: 'Defog',
};